import React from 'react';
import Grid, { GridProps } from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';

const SelectGrid: React.FC<GridProps> = withStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      maxWidth: 300,
      marginLeft: 'auto',
    },
  },
}))(Grid);

export default SelectGrid;
